import type { DesignationTrafficLight, MapLegendEntry } from '@/lib/api/map';
import styles from './MapLegendEntries.module.css';

type Props = {
  entries: MapLegendEntry[];
  className?: string;
  compact?: boolean;
  showTrafficLight?: boolean;
};

function trafficLightClass(light: DesignationTrafficLight | undefined): string {
  switch (light) {
    case 'green':
      return styles.ramzorGreen;
    case 'yellow':
      return styles.ramzorYellow;
    case 'red':
      return styles.ramzorRed;
    default:
      return styles.ramzorUnknown;
  }
}

export default function MapLegendEntries({
  entries,
  className,
  compact = false,
  showTrafficLight = true,
}: Props) {
  const listClass = [
    styles.list,
    compact ? styles.listCompact : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <ul className={listClass}>
      {entries.map((item) => (
        <li key={`${item.code}-${item.label}`} className={styles.item}>
          {showTrafficLight && item.traffic_light ? (
            <span
              className={`${styles.ramzorDot} ${trafficLightClass(item.traffic_light)}`}
              title={item.traffic_light}
              aria-hidden
            />
          ) : null}
          <span
            className={item.pattern === 'hatch' ? styles.swatchHatch : styles.swatch}
            style={{ backgroundColor: item.color }}
            aria-hidden
          />
          <span>{item.label}</span>
        </li>
      ))}
    </ul>
  );
}
